import { CHARTS } from '../constants';
import i18n from '../../../utils/i18n';
import React from 'react';
import Typography from '@material-ui/core/Typography';

export const buildSelectItems = charts => {
	const items = charts.map(chart => {
		const chartConst = CHARTS[chart.chartName];

		return {
			label: chartConst ? <Typography>{chartConst.menuLabel}</Typography> : <Typography>{chart.chartName}</Typography>,
			value: chart.chartName
		};
	});

	return [{ label: <Typography>{i18n.t('components.charts.labels.all')}</Typography>, value: 'All' }, ...items];
};
